import { ChevronRight } from 'lucide-react';
import { Card, Chip } from '@/ui/primitives';
import type { HistoryItem } from '../schemas';

interface Props {
  item: HistoryItem;
  onSelect: () => void;
}

export function HistoryCard({ item, onSelect }: Props) {
  const isDecision = item.kind === 'decision';
  const tag = isDecision ? 'DECISÃO' : 'LIÇÃO';
  const tone = isDecision ? 'info' : 'ok';
  const sub = isDecision ? item.date : (item.section ?? item.date ?? '—');

  return (
    <Card
      hover
      className="flex flex-col gap-2 cursor-pointer"
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
    >
      <div className="flex items-center justify-between">
        <Chip tone={tone} size="sm">
          {tag}
        </Chip>
        {sub && <span className="text-[10px] text-text-muted">{sub}</span>}
      </div>
      <div className="flex items-start justify-between gap-2">
        <span className="text-sm font-medium text-text leading-snug">{item.title}</span>
        <ChevronRight size={14} strokeWidth={1.5} className="text-text-muted shrink-0 mt-0.5" />
      </div>
      {item.description && (
        <p className="text-xs text-text-2 line-clamp-2">{item.description}</p>
      )}
    </Card>
  );
}
